import { Injectable } from '@angular/core';
import { ApolloQueryResult } from '@apollo/client/core';
import { FetchPolicy } from '@core/enums/fetch-policy-apollo.enum';
import { GetListParams } from '@core/interfaces/get-list.interface';
import { Apollo, gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { SalaryCalculationFilter, SalaryCalculationResponse } from '@core/interfaces/salary-calculation.interface';

@Injectable({
  providedIn: 'root',
})
export class SalaryCalculationService {
  constructor(private apollo: Apollo) {}

  public getSalaryCalculation(
    params: GetListParams<SalaryCalculationFilter>,
  ): Observable<ApolloQueryResult<SalaryCalculationResponse>> {
    return this.apollo.query<SalaryCalculationResponse>({
      query: gql`
        query getSalaryCalculation(
          $filter: SalaryCalculationFilterDto
          $pagination: OffsetPaginationInput
          $sort: SalaryCalculationSortInput
        ) {
          getSalaryCalculation(filter: $filter, pagination: $pagination, sort: $sort) {
            result {
              courierId
              courierName
              plannedHours
              workedHours
              plannedSalary
              earnedSalary
              fuelCost
              vehicleDepreciation
              totalSalary
            }
            total
          }
        }
      `,
      variables: {
        filter: params.filter,
        pagination: params.pagination,
        sort: params.sort,
      },
      fetchPolicy: FetchPolicy.NoCache,
    });
  }
}
